import { ProblemFeatureAnswer } from './../../Models/problem-feature-answer';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Problem } from '../../Models/problem';
import { ServiceBase } from '../../shared/service-base/service-base';
import { TServicePagingResult } from '../../shared/Infra/TServicePagingResult';
import { TServiceResult } from '../../shared/Infra/TServiceResult';
import { ServiceResult } from '../../shared/Infra/ServiceResult';
import { TermFilter } from '../../shared/Infra/term-filter';
import { SearchFilter } from '../../shared/Infra/Expression/search-filter';
import { BranchFilter } from '../../shared/Infra/Expression/branch-filter';
import { MightyServe } from '../../Models/mighty-serve';
import { ProblemIssue } from '../../Models/problem-issue';
import { ProblemIssueType } from '../../Models/problem-issue-type';
import { LocalRepository } from '../data/repository/local-repository';
import { MegaSearchSuggestion } from '../../Models/mega-search-suggestion';
import { ProblemMegaSearchFilter } from '../../Models/problem-mega-search-filter';
import { ProblemGallery } from '../../Models/problemGallery';
import { ChangePrablemStatusDto } from '../../Models/changeProblemStatusDto';
import { removeProbmelDto } from '../../Models/remove-problem-dto';
import { CategoryReferenceEnum } from '../enums/categoryReferenceEnum';
import { MegaFilter } from '../Infra/Expression/mega-filter';

@Injectable()
export class ProblemService extends ServiceBase<Problem> {
  constructor(http: HttpClient, repo: LocalRepository) {
    super('Problem', http, repo);
  }

  public getProblemByFilter(filter: SearchFilter): Observable<TServicePagingResult<Problem[]>> {
    return this.http.post<TServicePagingResult<Problem[]>>(`${this.ApiUrl}/GetProblemByFilter`, filter);
  }
  public getItemsByTermFilter(filter: TermFilter, categoryId: number, problemStatusId: string, branchIds: number[]): Observable<TServicePagingResult<Problem[]>> {
    return this.http.post<TServicePagingResult<Problem[]>>(
      `${this.ApiUrl}/GetItemsByTermFilter?categoryId=` + categoryId + '&problemStatusId=' + problemStatusId,
      { TermFilter: filter, BranchIds: branchIds }
    );
  }
  public getBySearchFilter(megaFilter: MegaFilter): Observable<TServicePagingResult<Problem[]>> {
    return this.http.post<TServicePagingResult<Problem[]>>(`${this.ApiUrl}/GetBySearchFilter`, megaFilter);
  }

  public getItemsBySearchFilter(brnachFilter: BranchFilter): Observable<TServicePagingResult<Problem[]>> {
    return this.http.post<TServicePagingResult<Problem[]>>(`${this.ApiUrl}/GetItemsBySearchFilter`, brnachFilter);
  }
  public getItemsBySearchFilterRefrence(brnachFilter: BranchFilter, categoryReference: CategoryReferenceEnum): Observable<TServicePagingResult<Problem[]>> {
    return this.http.post<TServicePagingResult<Problem[]>>(`${this.ApiUrl}/GetReferenceItemBySearchFilter?categoryReference=${categoryReference}`, brnachFilter);
  }

  getFamilyProblems(id): Observable<TServiceResult<Problem[]>> {
    return this.http.get<TServiceResult<Problem[]>>(`${this.ApiUrl}/GetByFamilyId/${id}`);
  }

  getFamilyMemberProblems(familyMemberId): Observable<TServiceResult<Problem[]>> {
    return this.http.get<TServiceResult<Problem[]>>(`${this.ApiUrl}/GetFamilyMemberProblems/${familyMemberId}`);
  }

  saveProblem(problem: Problem): Observable<TServiceResult<number>> {
    return this.http.post<TServiceResult<number>>(`${this.ApiUrl}/Save`, problem);
  }

  getDetailsById(problemId: number): Observable<TServiceResult<Problem>> {
    return this.http.get<TServiceResult<Problem>>(`${this.ApiUrl}/GetDetailsById/${problemId}`);
  }

  rProblem(rpdto: removeProbmelDto): Observable<ServiceResult> {
    const dd = `${this.ApiHeaderKey}`;
    const vv = this.ApiVersion2;
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append(dd, vv.toString());
    return this.http.post<ServiceResult>(`${this.ApiUrl}/Remove`, rpdto,
      { headers: headers }
    )
  }

  changeProblemStatus(problem: ChangePrablemStatusDto): Observable<ServiceResult> {
    const dd = `${this.ApiHeaderKey}`;
    const vv = this.ApiVersion2;
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append(dd, vv.toString());
    return this.http.put<ServiceResult>(`${this.ApiUrl}/ChangeProblemStatus`, problem, { headers: headers });
  }

  changeProblemFeatureAnswerStatus(item: ProblemFeatureAnswer): Observable<ServiceResult> {
    return this.http.post<ServiceResult>(`${this.ApiUrl}/ChangeProblemFeatureAnswerStatus`, item);
  }

  SetProblemWishHelp(problemId: number): Observable<TServiceResult<string>> {
    return this.http.get<TServiceResult<string>>(`${this.ApiUrl}/SetProblemWishHelp?problemId=` + problemId);
  }

  getByMemberId(id): Observable<TServiceResult<Problem[]>> {
    return this.http.get<TServiceResult<Problem[]>>(`${this.ApiUrl}/GetByMemberId/${id}`);
  }

  getProblemsByMsId(id): Observable<TServiceResult<Problem[]>> {
    return this.http.get<TServiceResult<Problem[]>>(`${this.ApiUrl}/GetProblemsByMsId?mightyServeId=` + id);
  }
  getRelatedProblemsByMsId(id): Observable<TServiceResult<Problem[]>> {
    return this.http.get<TServiceResult<Problem[]>>(`${this.ApiUrl}/GetRelatedProblemsByMsId?mightyServeId=` + id);
  }

  getProblemsByMs(ms: MightyServe): Observable<TServiceResult<Problem[]>> {
    return this.http.post<TServiceResult<Problem[]>>(`${this.ApiUrl}/GetProblemsByMs`, ms);
  }
  getByBranchTerm(filter: TermFilter, id: number): Observable<TServicePagingResult<Problem[]>> {
    return this.getByBranchTermWhitStatusEnaum(filter, id, null);
  }
  getByBranchTermWhitStatusEnaum(filter: TermFilter, id: number, statusId: number): Observable<TServicePagingResult<Problem[]>> {
    return this.http.post<TServicePagingResult<Problem[]>>(`${this.ApiUrl}/GetByBranchTerm?id=${id}&StatusEnum=${statusId}`, filter);
  }

  getTopThreeProblems(max: number): Observable<TServiceResult<Problem[]>> {
    return this.http.get<TServiceResult<Problem[]>>(`${this.ApiUrl}/getTopThreeProblems?max=${max}`);
  }
  setConfirm(problemId: number, activate: boolean): Observable<ServiceResult> {
    return this.http.get<ServiceResult>(`${this.ApiUrl}/SetConfirm?problemId=${problemId}&activate=${activate}`);
  }

  getByFamilyId(id: number): Observable<TServiceResult<Problem[]>> {
    return this.http.get<TServiceResult<Problem[]>>(`${this.ApiUrl}/GetByFamilyId?id=${id}`);
  }
  saveProblemRating(problem: Problem): Observable<TServiceResult<number>> {
    return this.http.post<TServiceResult<number>>(`${this.ApiUrl}/SaveProblemRating`, problem);
  }

  getProblemIssueTypes(): Observable<TServiceResult<ProblemIssueType[]>> {
    return this.http.get<TServiceResult<ProblemIssueType[]>>(`${this.ApiUrl}/GetProblemIssueTypes`);
  }
  getProblemIssues(id: number): Observable<TServiceResult<ProblemIssue>> {
    return this.http.get<TServiceResult<ProblemIssue>>(`${this.ApiUrl}/GetProblemIssue?ProblemId=${id}`);
  }
  saveProblemIssues(ProblemIssue: ProblemIssue): Observable<TServiceResult<ProblemIssue>> {
    return this.http.post<TServiceResult<ProblemIssue>>(`${this.ApiUrl}/SaveProblemIssue`, ProblemIssue);
  }
  setMainScreenState(problemId: number, activate: boolean): Observable<ServiceResult> {
    return this.http.get<ServiceResult>(`${this.ApiUrl}/SetMainScreenState?problemId=${problemId}&isVisible=${activate}`);
  }

  findProllemBySearch(filter: SearchFilter): Observable<TServiceResult<number>> {
    return this.http.post<TServiceResult<number>>(`${this.ApiUrl}/FindProblemBySearch `, filter)
  }

  public createGallery(problemId: number, image: ProblemGallery): Observable<TServiceResult<ProblemGallery>> {
    return this.http.post<TServiceResult<ProblemGallery>>(`${this.ApiUrl}/CreateGallery/${problemId}`, image);
  }
  public RemoveImage(problemGalleryId: number): Observable<ServiceResult> {
    return this.http.delete<ServiceResult>(`${this.ApiUrl}/DeleteGallery/${problemGalleryId}`)
  }
  public getImages(problemId: number): Observable<TServiceResult<string[]>> {
    return this.http.get<TServiceResult<string[]>>(`${this.ApiUrl}/GalleryImages/${problemId}`);
  }
  public getImagesAdmin(problemId: number): Observable<TServiceResult<ProblemGallery[]>> {
    return this.http.post<TServiceResult<ProblemGallery[]>>(`${this.ApiUrl}/GalleryImagesAdmin/${problemId}`, null);
  }

  public problemAndCategorySearchSuggestion(provinceId: number, searchParam: string)
    : Observable<TServiceResult<MegaSearchSuggestion>> {
    return this.http.get<TServiceResult<MegaSearchSuggestion>>(`${this.ApiUrl}/` +
      `ProblemAndCategorySearch?ProvinceId=${provinceId}&` +
      `searchParam=${searchParam}`);
  }

  public problemMegaSearch(megaFilter: ProblemMegaSearchFilter):
    Observable<TServicePagingResult<Problem[]>> {
    return this.http
      .post<TServicePagingResult<Problem[]>>(
        `${this.ApiUrl}/ProblemMegaSearch`, megaFilter,
        {
          headers: { 'client-cache': 'on' }
        });
  }

  getProblemExcel(brnachFilter: BranchFilter): Observable<TServiceResult<string>> {
    return this.http.post<TServiceResult<string>>(`${this.ApiUrl}/GetProblemExcel`, brnachFilter);
  }

  ChangeStatusGallery(image: ProblemGallery): Observable<ServiceResult> {
    return this.http.post<ServiceResult>(`${this.ApiUrl}/ChangeStatusGallery`, image);
  }

}
